<template>
  <div class="main-wrapper">
    <img class="main-image" id="main-image" src="@/assets/img/background/1920x1080.jpg"/>
    <div class="inundaciones">
      <img src="@/assets/img/background/1920x1080_area_inundable.png"/>
    </div>
    <div class="area-of-projects" v-show="interfaceState.shapes">
      <img v-for="project in data.projects"
        :id="`shape${project.id}`"
        :key="`shape${project.id}`"
        :src="getShapesUrl(project)"
      />
      <img v-for="project in data.projects"
        :id="`pin${project.id}`"
        :key="`pin${project.id}`"
        :src="getSVGImageUrl(project, 'pin')"
      />
      <img v-for="project in data.projects"
        :id="`cierre${project.id}`"
        :key="`cierre${project.id}`"
        :src="getSVGImageUrl(project, 'cierre')"
        v-show="project.currentState === 'finished'"
      />
      <img
        v-for="project in data.projects"
        :id="`planificacion${project.id}`"
        :key="`planificacion${project.id}`"
        :src="getSVGImageUrl(project, 'planificacion')"
        v-show="project.currentState === 'planification'"
      />
      <img v-for="project in data.projects"
        :id="`ejecucion${project.id}`"
        :key="`ejecucion${project.id}`"
        :src="getSVGImageUrl(project, 'ejecucion')"
        v-show="project.currentState === 'execution'"
      />
      <img v-for="project in data.projects"
        :id="`tooltip${project.id}`"
        :key="`tooltip${project.id}`"
        :src="getSVGImageUrl(project, 'tooltip')"
        v-show="currentPopover === project.id"
      />
    </div>
    <div class="projects" id="project-container" v-show="resized">
      <ProjectPin class="project"
        :id="'project' + project.id"
        v-for="project in data.projects"
        :key="project.id"
        :style="getMarkerStyle(project)"
        :project="project"
        @mouseover="currentPopover = project.id"
        @mouseout="currentPopover = -1"
        :showPopover="currentPopover === project.id"
      >
      </ProjectPin>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import { STATIC_FILES_GATEWAY_BASE_URL } from '@/constants'
import colorPropertyMixin from '@/mixins/color-property.js'

export default {

  mixins: [
    colorPropertyMixin
  ],

  components: {
    ProjectPin: _ => import('./ProjectPin')
  },

  computed: {
    ...mapGetters([
      'interfaceState',
      'data'
    ])
  },

  data () {
    return {
      currentPopover: -1,
      resized: true
    }
  },

  mounted () {
    if (window.widthGt1920) this.handleUltraWideResolution()
  },

  methods: {

    /**
     * This resize some components to match the height of the image
     *
     * The height of the image dictates everything
     */
    handleUltraWideResolution () {
      this.resized = false
      const targetImage = document.getElementById('main-image')

      targetImage.addEventListener('load', () => {
        this.resized = true
        const projects = document.getElementById('project-container')
        projects.style.height = targetImage.height + 'px'
      })
    },

    /**
     * This return the url of the area of influence of a project
     * @param project the project
     * @returns {string} the url
     */
    getShapesUrl (project) {
      return `${STATIC_FILES_GATEWAY_BASE_URL}/${project.code}/shapes/01.svg`
    },

    /**
     * This return the url of the area of influence of a project
     * @param project the project
     * @returns {string} the url
     */
    getSVGImageUrl (project, img) {
      return `${STATIC_FILES_GATEWAY_BASE_URL}/${project.code}/${img}/${img}.svg`
    },

    /**
     * Returns the location of the project with the color to use
     * with a div or something that is floating
     */
    getMarkerStyle (project) {
      if (!project.markerPositions) return { }
      return { ...project.markerPositions }
    }

  }
}

</script>
<style scope>

.main-image {
  background-image: url("~@/assets/img/background/1920x1080.jpg");
  min-width: 100vmax;
  min-width: 100vw;
  min-height: 100vmin;
  min-height: 100vh;
}

.main-wrapper > div {
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
}

.main-wrapper img {
  min-height: 100vmin;
  min-height: 100vh;
  min-width: 100vmax;
  min-width: 100vw;
}

.project {
  position: absolute;
}

.area-of-projects{
  width: 100vw !important;
  height: 100vh !important;
  overflow: scroll;
}

.area-of-projects:first-child {
  position: relative;
  top: 0;
  left: 0;
}

.area-of-projects > img {
  position: absolute;
  min-width: 100%;
  min-height: 100%;
  top: 0;
  left: 0;
}

.projects:first-child {
  position: relative;
}

.projects > div {
  position: absolute;
  top: 0;
  left: 0;
}

.project > div {
  position: absolute;
}

</style>
